<valben-header
    [contentType]="contentType"
    [editEnabled]="editEnabled"
    (contentTypeChange)="setContentType($event)"
    [isKngPage]=true
    [showKngNavigationButtons]="false">
</valben-header>

<div
    class="relative grow overflow-y-auto"
    [ngSwitch]="contentType"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading$ | async}">

    @if (loading$ | async) {
        <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div *ngSwitchCase="0">
        <valben-table
            (editEvent)="editOnClick($event)"
            [columns]="cols"
            [values]="tableValues"
            [refresh]="refresh"
            [showHistory]="false"
            (landlordDataSave)="saveLandlordData($event)">
        </valben-table>
    </div>

    <div
        *ngSwitchCase="2"
        class="flex flex-col gap-4 bg-valamargray border-2 static p-4"
        [ngClass]="(loading$ | async) ? 'blur-[2px] pointer-events-none [&_*]:select-none' : ''"
    >
        <button class="flex valben-button text-lg ml-auto" (click)="modify()">Spremi</button>
        <valben-text-input
            [key]="modifyKngKeys.Name"
            [itemObservable]="editItemObservable"
            [update]="updateEditName"
            title="Ime"
            [error]="mErrors[modifyKngKeys.Name]"
            [preview]="true"
        ></valben-text-input>
        <valben-text-input
            [key]="modifyKngKeys.Surname"
            [itemObservable]="editItemObservable"
            [update]="updateEditSurname"
            title="Prezime"
            [error]="mErrors[modifyKngKeys.Surname]"
            [preview]="true"
        ></valben-text-input>
        <valben-text-input
            [key]="modifyKngKeys.OIB"
            [itemObservable]="editItemObservable"
            [update]="updateEditOib"
            title="OIB"
            [error]="mErrors[modifyKngKeys.OIB]"
            [preview]="true"
        ></valben-text-input>
        <valben-text-input
            [key]="modifyKngKeys.ResidenceAddress"
            [itemObservable]="editItemObservable"
            [update]="updateEditResidenceAddress"
            title="Adresa prebivališta"
            [error]="mErrors[modifyKngKeys.ResidenceAddress]"
            [preview]="true"
        ></valben-text-input>
        <valben-text-input
            [key]="modifyKngKeys.PhoneNumber"
            [itemObservable]="editItemObservable"
            [update]="updateEditPhoneNumber"
            title="Broj telefona"
            [error]="mErrors[modifyKngKeys.PhoneNumber]"
        ></valben-text-input>
        <valben-text-input
            [key]="modifyKngKeys.Email"
            [itemObservable]="editItemObservable"
            [update]="updateEditEmail"
            title="E-mail"
            [error]="mErrors[modifyKngKeys.Email]"
        ></valben-text-input>
        <valben-number-input
            [key]="modifyKngKeys.EmployeeMonthlyIncome"
            [itemObservable]="editItemObservable"
            [update]="updateEditEmployeeMonthlyIncome"
            title="Mjesečni prihod djelatnika"
            [error]="mErrors[modifyKngKeys.EmployeeMonthlyIncome]"
        ></valben-number-input>
        <valben-file-input
            [key]="modifyKngKeys.EmployeePropertyDocument"
            [itemObservable]="editItemObservable"
            [update]="updateEditEmployeePropertyDocument"
            title="Dokument o vlasništvu nad nekretninom"
            fileType="application/pdf"
            [error]="mErrors[modifyKngKeys.EmployeePropertyDocument]"
            [isKng]="true"
            [optional]="false"
        ></valben-file-input>
        <valben-number-input
            [key]="modifyKngKeys.NumberOfChildren"
            [itemObservable]="editItemObservable"
            [update]="updateEditNumberOfChildren"
            title="Broj djece/maloljetnih ukućana u kućanstvu"
            [error]="mErrors[modifyKngKeys.NumberOfChildren]"
        ></valben-number-input>
        @if (numberOfChildren > 0) {
            <div class="tw-space-y-6">
                @for (_ of [].constructor(numberOfChildren); track $index; let i = $index) {
                <div
                    class="tw-border tw-border-gray-900/10 tw-rounded-md tw-p-4">
                    <div class="tw-font-semibold tw-text-lg tw-mb-3">
                        Dijete {{ i + 1 }}
                    </div>
                    <valben-file-input
                        [key]="modifyKngKeys.MinorFamilyMembersBirthCertificates"
                        [itemObservable]="editItemObservable"
                        [update]="updateEditMinorFamilyMemberBirthCertificateAt(i)"
                        [index]="i"
                        title="Rodni list"
                        fileType="application/pdf"
                        [error]="mErrors[modifyKngKeys.MinorFamilyMembersBirthCertificates]"
                        [isKng]="true"
                        [optional]="false"
                    ></valben-file-input>
                </div>
                }
            </div>
        }
        <valben-number-input
            [key]="modifyKngKeys.NumberOfFamilyMembers"
            [itemObservable]="editItemObservable"
            [update]="updateEditNumberOfFamilyMembers"
            title="Broj punoljetnih ukućana u kućanstvu"
            [error]="mErrors[modifyKngKeys.NumberOfFamilyMembers]"
        ></valben-number-input>
        @if (numberOfFamilyMembers > 0) {
            <div class="tw-space-y-6">
                @for (i of familyMemberIndexes; track i) {
                <div
                    class="tw-border tw-border-gray-900/10 tw-rounded-md tw-p-4">
                    <div class="tw-font-semibold tw-text-lg tw-mb-3">
                        Ukućan {{ i + 1 }}
                    </div>
        
                        <valben-adult-family-member
                            [index]="i"
                            [itemObservable]="editItemObservable"
                            [update]="updateEditAdultFamilyMember"
                            [showMonthlyIncome]="true"
                            [error]="mErrors[modifyKngKeys.AdultFamilyMembers]"
                        ></valben-adult-family-member>
        
                </div>
                }
            </div>
        }
        <valben-boolean-input
            [key]="modifyKngKeys.IsSingleParent"
            [itemObservable]="editItemObservable"
            [update]="updateEditIsSingleParent"
            title="Samohran roditelj"
            [error]="mErrors[modifyKngKeys.IsSingleParent]"
        ></valben-boolean-input>
        @if (isSingleParent) {
            <valben-file-input
                [key]="modifyKngKeys.SingleParentConfirmation"
                [itemObservable]="editItemObservable"
                [update]="updateEditSingleParentConfirmation"
                title="Potvrda samohranog roditelja"
                fileType="application/pdf"
                [error]="mErrors[modifyKngKeys.SingleParentConfirmation]"
                [isKng]="true"
                [optional]="false"
            ></valben-file-input>
        }
        <valben-dropdown-input
            [key]="modifyKngKeys.CurrentAccomodation"
            [itemObservable]="editItemObservable"
            [update]="updateEditCurrentAccomodation"
            [options]="currentAccomodationOptions"
            optionLabel="label"
            optionValue="value"
            title="Trenutni smještaj"
            placeholder="Odaberi smještaj"
            [error]="mErrors[modifyKngKeys.CurrentAccomodation]"
        ></valben-dropdown-input>
        <valben-boolean-input
            [key]="modifyKngKeys.OwnsPropertyCloserThan30Km"
            [itemObservable]="editItemObservable"
            [update]="updateEditOwnsPropertyCloserThan30Km"
            title="Posjeduje li djelatnik slobodnu nekretninu bliže od 30 km"
            [error]="mErrors[modifyKngKeys.OwnsPropertyCloserThan30Km]"
        ></valben-boolean-input>
        <valben-boolean-input
            [key]="modifyKngKeys.OwnsPropertyFurtherThan30Km"
            [itemObservable]="editItemObservable"
            [update]="updateEditOwnsPropertyFurtherThan30Km"
            title="Posjeduje li djelatnik slobodnu nekretninu dalje od 30km"
            [error]="mErrors[modifyKngKeys.OwnsPropertyFurtherThan30Km]"
        ></valben-boolean-input>
        <valben-boolean-input
            [key]="modifyKngKeys.OwnsLeaseAgreement"
            [itemObservable]="editItemObservable"
            [update]="updateEditOwnsLeaseAgreement"
            title="Posjeduje li ugovor o najmu"
            [error]="mErrors[modifyKngKeys.OwnsLeaseAgreement]"
        ></valben-boolean-input>
        @if (ownsLeaseAgreement) {
            <valben-file-input
                [key]="modifyKngKeys.ResidenceCertificate"
                [itemObservable]="editItemObservable"
                [update]="updateEditResidenceCertificate"
                title="Prenesi potvrdu prebivališta"
                [isKng]="true"
                fileType="application/pdf"
                [error]="mErrors[modifyKngKeys.ResidenceCertificate]"
            ></valben-file-input>
        }
        <valben-boolean-input
            [key]="modifyKngKeys.LookingForApartment"
            [itemObservable]="editItemObservable"
            [update]="updateEditLookingForApartment"
            title="Traži li djelatnik stan"
            [error]="mErrors[modifyKngKeys.LookingForApartment]"
        ></valben-boolean-input>
        <valben-boolean-input
            [key]="modifyKngKeys.ConsentsToPrivacyPolicy"
            [itemObservable]="editItemObservable"
            [update]="updateEditConsentsToPrivacyPolicy"
            title="Slaže se s politikom privatnosti"
            [error]="mErrors[modifyKngKeys.ConsentsToPrivacyPolicy]"
        ></valben-boolean-input>
        <div class="flex gap-4 justify-end items-center select-none">
            <button class="valben-button text-lg" (click)="back(true)">Natrag</button>
            <button class="valben-button text-lg" (click)="confirmCancel($event)">Otkaži</button>
            <button class="valben-button text-lg" (click)="modify()">Spremi</button>
        </div>
    </div>
</div>
